// extracted by mini-css-extract-plugin
export var highlightFade = "_34-4";
export var highlighted = "_34-3";
export var table = "_34-1";
export var tableContainer = "_34-0";
export var totalsRow = "_34-2";